/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureResource extends models.TagPostureResourceBase {
    constructor() {
        super();
        this.setDiscriminator("TagPostureResource");
    }

    getFixupPrototypeFunction() { return TagPostureResource.fixupPrototype; }

    static newInstance(model: Partial<TagPostureResource>): TagPostureResource {
        let obj = Object.assign(new TagPostureResource(), model);
        TagPostureResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureResource>): TagPostureResource {
        if (!model) return null;
        return TagPostureResource.newInstance(<TagPostureResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureResource) {
        if (!obj) return;

        models.TagPostureResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureResource): boolean {
        if (models.TagPostureResourceBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagPostureResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.resource_tags) {
            for (let val of this.resource_tags) {
                models.TagPostureTagDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * List of tags for the resource
     */
    resource_tags: Array<models.TagPostureTagDetails>;

}
